import { useState, useEffect, useCallback } from "react";

function useClick(onClick, onDoubleClick) {
  const [clicks, setClicks] = useState(0);

  useEffect(() => {
    let singleClickTimer;
    if (clicks === 1) {
      singleClickTimer = setTimeout(function () {
        onClick();
        setClicks(0);
      }, 250);
    } else if (clicks === 2) {
      onDoubleClick();
      setClicks(0);
    }
    return () => clearTimeout(singleClickTimer);
  }, [clicks, onClick, onDoubleClick]);

  return useCallback(() => setClicks((clicks) => clicks + 1), []);
}

export default useClick;
